import * as $ from "jquery";
import * as JSZip from "jszip";
(<any>window).jQuery = $;
(<any>window).JSZip = JSZip;

import "bootstrap";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "jquery-countdown";

import { KnockoutInitialization } from "./Knockout/knockoutInitialization";
import { initPasswordEye } from "./scriptHelper";

$(() => {
    KnockoutInitialization.initKo();
    initPasswordEye();
    
    $('#clock').countdown($('#clock').data("endofperiod"), function (event) {
        $(this).html(event.strftime('%D nap %H:%M:%S'));
    });

    $('.dropdown-menu button.dropdown-toggle').on('click', function (e) {
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
        }
        var $subMenu = $(this).next('.dropdown-menu');
        $subMenu.toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.ef-dropdown-submenu .show').removeClass('show');
        });

        return false;
    });

    $("#organizationName").chosen({
        max_shown_results: 50,
        no_results_text: "Nem található..."
    });

    $(document).ajaxError((evt, request) => {
        if (request.status == 401) { // the client is not authenticated
            window.location.href = "Account/Login?SessionExpired=true";
        }
    });
});